import request from '@/utils/request'

export function batchCancelById(id) {
  return request({
    url: `/mim/newsInfo/cancel/${id}`,
    method: 'get',
  })
}

export function batchDeleteById(id) {
  return request({
    url: `/mim/newsInfo/delete/${id}`,
    method: 'get',
  })
}

export function getPage(condition, pagination) {
  return request({
    url: '/mim/newsInfo/pageList',
    method: 'post',
    data: { condition: condition, pagination: pagination }
  })
}

export function getInfo(id) {
  return request({
    url: `/mim/newsInfo/info/${id}`,
    method: 'get',
  })
}
export function postSaveOrUpdate(data) {
  return request({
    url: '/mim/newsInfo/saveOrUpdate',
    method: 'post',
    data
  })
}